import { useMemo } from "react";
import React from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import SocketDevCredentialsForm from "./SocketDevCredentialsForm";
import socketDevMappingForm from "./SocketDevMappingForm";

interface SocketDevConfigListingProps {
  name: string;
  loginConfigList: any;
  extraLoginConfigFields: any;
  triggerModifyParam: any;
  [key: string]: any;
}
const SocketDevConfigListing: React.FC<SocketDevConfigListingProps> = (
  props,
) => {
  const columns = useMemo(
    () => [
      {
        title: "Repository",
        dataIndex: "repositoryName",
        width: 240,
        render: columnRenderArrayData,
      },
    ],
    [],
  );
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={socketDevMappingForm}
      CredentialsForm={SocketDevCredentialsForm}
      extraColumns={columns}
    />
  );
};

export default SocketDevConfigListing;
